module.exports = __webpack_public_path__ + "static/img/logo-remedio-facil.27778b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/img/logo-remedio-facil.png
// module id = nkjI
// module chunks = 15